import { addObjectToFormData } from 'Shared/helpers';

import instance from './instance';

export function advanceOnboardingStateAsFormData({ onboardingState, didSkip }) {
  const data = new FormData();
  addObjectToFormData(data, onboardingState, 'onboarding_state');
  addObjectToFormData(data, didSkip, 'did_skip');
  return instance.putForm(`/onboarding_states/advance`, data);
}

export async function advanceOnboardingState({ onboardingState, didSkip }) {
  return instance.put(`/onboarding_states/advance`, {
    onboarding_state: onboardingState,
    did_skip: didSkip,
  });
}

export const updateOnboardingState = data => instance.put(`/onboarding_states`, data);

export const updateOnboardingStateFlowType = data => instance.put(`/onboarding_states/update_flow_type`, data);

export const submitThirdPartyBrowserEmail = ({ email }) =>
  instance.post(`/onboarding_states/third_party_browser_email`, { email });

export function backOnboardingState() {
  return instance.put(`/onboarding_states/back`);
}

export function updateAnonymous() {
  let ajsAnonymousId = null;
  if (localStorage) ajsAnonymousId = localStorage.getItem('ajs_anonymous_id');

  return instance.put(`/onboarding_states/update_anonymous`, {
    ajs_anonymous_id: ajsAnonymousId,
  });
}

export const fetchAgendaAiSlackChannels = () => instance.get('/onboarding_states/agenda_ai_slack_channels');

export const generateAgendaAiSuggestionsPoll = params =>
  instance.get('/onboarding_states/agenda_ai_suggestions_poll', { params });

export const generateAgendaAiSuggestions = ({ channelIds }) =>
  instance.post('/onboarding_states/agenda_ai_suggestions', { channelIds });

export const generateAgendaAiSuggestionsManual = data =>
  instance.post('/onboarding_states/agenda_ai_suggestions_manual', data);
